import classNames from 'classnames';
import FJDragBox from '../../../common/components/FJDragBox/FJDragBox';
import FJDisplayHeaderContainer from '../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJHistoryPanelContainer from '../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJFake3dCreationContainer from '../FJFake3dCreation/FJFake3dCreationContainer';
import styles from './FJFake3dRight.module.less';
import PropTypes from 'prop-types';
const FJFake3dRight = props => {
    const { headerTabIndex, setIsDraggingFile, uploadImg } = props;
    return (
        <FJDragBox setIsDragging={setIsDraggingFile} uploadFile={uploadImg} className={classNames(styles.app_right)}>
            <FJDisplayHeaderContainer />
            <FJFake3dCreationContainer active={headerTabIndex === 0} />
            <FJHistoryPanelContainer activeHeaderTabIndex={1} />
        </FJDragBox>
    );
};

FJFake3dRight.propTypes = {
    headerTabIndex: PropTypes.number,
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
};

export default FJFake3dRight;
